import Modal from "@/components/ui/modal_new/Modal";
import React from "react";

interface IProps {
  open: boolean;
  onClose: () => void;
}

const LensTypeOverlay = ({ onClose, open }: IProps) => {
  return (
    <Modal isOpen={open} onClose={onClose}>
      LensTypeOverlay
    </Modal>
  );
};

export default LensTypeOverlay;
